// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

// Babel
require('core-js/stable');
require('regenerator-runtime/runtime');

// Modules
const navigationModule = require('../modules/navigation');
const cookieHandler = require('../handlers/cookie-statement-handler');

// CSS
require('../../css/legal.css');


/**
 * Init
 */

// Initialize navigation
navigationModule.initialize();

// Initialize cookie handler
cookieHandler.handlerDidLoad();
